/* Cart display for product.metafields.bundler.included_products */
(function () {
  'use strict';

  if (customElements.get('sc-cart-bundle-included')) return;

  var PRODUCT_ORDER = ['Bügel', 'Deckel', 'Korpus', 'Einlegeboden', 'Transportring'];

  var COLOR_ALIASES = {
    deepblack: ['deepblack', 'tiefschwarz', 'schwarz', 'black'],
    silvergrey: ['silvergrey', 'silbergrau', 'silber'],
    champagner: ['champagner', 'champagne', 'beige'],
    reinweiss: ['reinweiss', 'reinweiss', 'weiss', 'weiss', 'white'],
  };

  var FORM_VALUES = [
    'oval',
    'eckig',
    'basic',
    'edge',
    'rund',
    'quadrat',
    'round',
    'square',
    'rechteck',
    'rectangle',
  ];

  function norm(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '');
  }

  function colorsMatch(a, b) {
    var na = norm(a);
    var nb = norm(b);
    if (!na || !nb) return false;
    if (na === nb) return true;
    for (var key in COLOR_ALIASES) {
      var aliases = COLOR_ALIASES[key];
      if (aliases.indexOf(na) !== -1 && aliases.indexOf(nb) !== -1) return true;
    }
    return false;
  }

  function classifyOptionRole(optionName) {
    var n = norm(optionName);
    if (/buegel|henkel|griff|handle/.test(n)) return 'handle';
    if (/korbfarbe|korpfarbe|bodycolor|bodyfarbe|korperfarbe/.test(n)) return 'body';
    if (/form|shape|grundform|lkshape/.test(n)) return 'form';
    if (/farbe|color|colour|couleur/.test(n)) {
      if (/korb/.test(n)) return 'body';
      return 'unknown';
    }
    return 'unknown';
  }

  function isFormValue(value) {
    return FORM_VALUES.indexOf(norm(value)) !== -1;
  }

  function isBuegelProduct(productName) {
    return /bügel|buegel|henkel|griff|handle/i.test(productName);
  }

  function isFormColorProduct(productName) {
    return /korpus|deckel|einlegeboden|transportring|boden|ring|deck/i.test(productName);
  }

  function variantOptionValues(variant) {
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  function relevantCriteria(pairs, productName) {
    var isBuegel = isBuegelProduct(productName);
    var isFormColor = isFormColorProduct(productName);
    var hasBody = pairs.some(function (entry) {
      return entry.role === 'body' && entry.value;
    });

    return pairs.filter(function (entry) {
      if (!entry.value) return false;
      if (entry.role === 'handle') return isBuegel;
      if (entry.role === 'form') return isFormColor;
      if (entry.role === 'body') return isBuegel || isFormColor;
      if (entry.role === 'unknown') {
        if (isFormValue(entry.value)) return isFormColor;
        if (hasBody && isFormColor) return false;
        if (isBuegel) return true;
        if (isFormColor) return true;
      }
      return !isBuegel && !isFormColor;
    });
  }

  function classifyVariantOptions(variant, productName) {
    var values = variantOptionValues(variant);
    var isBuegel = isBuegelProduct(productName);
    var classified = [];
    var colorCount = 0;

    values.forEach(function (value) {
      if (isFormValue(value)) {
        classified.push({ role: 'form', value: value });
        return;
      }
      if (isBuegel) {
        classified.push({ role: colorCount === 0 ? 'handle' : 'body', value: value });
        colorCount++;
        return;
      }
      classified.push({ role: 'body', value: value });
    });

    return classified;
  }

  function rolesCompatible(criterionRole, optionRole) {
    if (!criterionRole || criterionRole === 'unknown') return true;
    if (!optionRole || optionRole === 'unknown') return true;
    return criterionRole === optionRole;
  }

  function scoreVariant(variant, criteria, productName) {
    if (!criteria.length) return -1;

    var classified = classifyVariantOptions(variant, productName);
    var matched = 0;
    var quality = 0;

    criteria.forEach(function (entry) {
      var bestOpt = null;
      classified.forEach(function (opt) {
        if (!rolesCompatible(entry.role, opt.role)) return;
        if (!colorsMatch(opt.value, entry.value)) return;
        if (!bestOpt || norm(opt.value) === norm(entry.value)) bestOpt = opt;
      });
      if (!bestOpt) return;

      matched++;
      if (entry.role === 'body') quality += 10;
      if (norm(bestOpt.value) === norm(entry.value)) quality += 5;
    });

    return matched * 1000 - (criteria.length - matched) * 100 + quality;
  }

  function matchVariantForProduct(variants, selection, productName) {
    var criteria = relevantCriteria(selection.pairs, productName);

    if (!criteria.length && selection.pairs.length) {
      criteria = selection.pairs.filter(function (entry) {
        return entry.value;
      });
    }

    if (!criteria.length) return variants[0] || null;

    var best = null;
    var bestScore = -Infinity;

    variants.forEach(function (variant) {
      var score = scoreVariant(variant, criteria, productName);
      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    });

    return best;
  }

  function productLabel(variant) {
    var name = variant.name || variant.title || '';
    if (name.indexOf(' - ') !== -1) return name.split(' - ')[0].trim();
    return name.trim();
  }

  function groupVariantsByProduct(variants) {
    var groups = {};
    var order = [];

    variants.forEach(function (variant) {
      var label = productLabel(variant);
      if (!label) return;
      if (!groups[label]) {
        groups[label] = [];
        order.push(label);
      }
      groups[label].push(variant);
    });

    order.sort(function (a, b) {
      var ai = PRODUCT_ORDER.indexOf(a);
      var bi = PRODUCT_ORDER.indexOf(b);
      if (ai === -1) ai = 999;
      if (bi === -1) bi = 999;
      return ai - bi;
    });

    return { groups: groups, order: order };
  }

  function imageSrc(variant) {
    var src =
      variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : variant.featured_media &&
            variant.featured_media.preview_image &&
            variant.featured_media.preview_image.src
          ? variant.featured_media.preview_image.src
          : '';
    if (src && src.indexOf('//') === 0) src = 'https:' + src;
    return src;
  }

  function formatOptions(variant) {
    return variantOptionValues(variant).join(' / ');
  }

  function resolveItems(variants, selection) {
    var grouped = groupVariantsByProduct(variants);
    var items = [];

    grouped.order.forEach(function (productName) {
      var match = matchVariantForProduct(grouped.groups[productName], selection, productName);
      if (!match) return;
      items.push({
        name: productName,
        image: imageSrc(match),
        options: formatOptions(match),
        url: match.url || '',
      });
    });

    return items;
  }

  function buildSelection(options) {
    return {
      pairs: (options || []).map(function (option) {
        return {
          name: option.name || '',
          value: option.value || '',
          role: classifyOptionRole(option.name || ''),
        };
      }),
    };
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  class ScCartBundleIncluded extends HTMLElement {
    connectedCallback() {
      if (this.__scInit) return;
      this.__scInit = true;

      var configEl = this.querySelector('[data-sc-cart-bundle-config]');
      if (!configEl) return;

      var config;
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      var variants = config.variants || [];
      if (!variants.length) return;

      var selection = buildSelection(config.options || []);
      var items = resolveItems(variants, selection);
      if (!items.length) return;

      this.quantity = Number(config.quantity || this.dataset.quantity || 1) || 1;
      this.hideLabel = this.dataset.hideLabel || '__COUNT__ Artikel ausblenden';
      this.showLabel = this.dataset.showLabel || '__COUNT__ Artikel einblenden';
      this.listEl = this.querySelector('[data-sc-cart-bundle-list]');
      this.toggleEl = this.querySelector('[data-sc-cart-bundle-toggle]');
      this.toggleLabelEl = this.querySelector('[data-sc-cart-bundle-toggle-label]');

      this.renderList(items);
      this.setupToggle(items.length);
    }

    labelWithCount(template, count) {
      return String(template || '').replace(/__COUNT__/g, String(count));
    }

    setupToggle(count) {
      if (!this.toggleEl || !this.listEl) return;

      this.toggleEl.hidden = false;
      this.listEl.hidden = false;
      this.dataset.expanded = 'true';
      this.toggleEl.setAttribute('aria-expanded', 'true');
      if (this.toggleLabelEl) {
        this.toggleLabelEl.textContent = this.labelWithCount(this.hideLabel, count);
      }

      this.toggleEl.addEventListener('click', function () {
        var expanded = this.dataset.expanded !== 'false';
        var next = !expanded;
        this.dataset.expanded = next ? 'true' : 'false';
        this.listEl.hidden = !next;
        this.toggleEl.setAttribute('aria-expanded', next ? 'true' : 'false');
        if (this.toggleLabelEl) {
          this.toggleLabelEl.textContent = this.labelWithCount(next ? this.hideLabel : this.showLabel, count);
        }
      }.bind(this));
    }

    renderList(items) {
      if (!this.listEl) return;

      var qty = this.quantity;
      this.listEl.innerHTML = items
        .map(function (item) {
          var media = item.image
            ? '<div class="sc-cart-bundle-included__media"><img src="' +
              escapeHtml(item.image) +
              '" alt="' +
              escapeHtml(item.name) +
              '" width="80" height="80" loading="lazy"></div>'
            : '<div class="sc-cart-bundle-included__media" aria-hidden="true"></div>';

          var options = item.options
            ? '<div class="sc-cart-bundle-included__options">' + escapeHtml(item.options) + '</div>'
            : '';

          return (
            '<li class="sc-cart-bundle-included__item">' +
            media +
            '<div class="sc-cart-bundle-included__body">' +
            '<div class="sc-cart-bundle-included__title">' +
            escapeHtml(qty + ' x ' + item.name) +
            '</div>' +
            options +
            '</div>' +
            '</li>'
          );
        })
        .join('');
    }
  }

  customElements.define('sc-cart-bundle-included', ScCartBundleIncluded);
})();
